var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222 64.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.39 29.49 128.46 29.49 129.3 35.24 160.39 35.24 160.39 29.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.39 18.15 126.8 18.15 127.64 23.89 160.39 23.89 160.39 18.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.39 40.84 130.12 40.84 130.96 46.59 160.39 46.59 160.39 40.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.47,6.8H125a8.38,8.38,0,0,1,.35,1.56l.61,4.19h35.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.78 52.19 132.63 57.93 171.16 57.93 161.21 52.19 131.78 52.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.5,21.39l1.9,16.46H98.5ZM88,58.12l4.55-7.9h17.56l1.29,7.9h15.33l-7.18-49a2.8,2.8,0,0,0-.66-1.54,2.37,2.37,0,0,0-2-.73H100.87L71.74,58.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.28,6.83l-6.12,11L61,39.53,60.63,9a3.35,3.35,0,0,0-.07-.44,3,3,0,0,0-.24-.64v0h0a2.5,2.5,0,0,0-.21-.35.9.9,0,0,0-.19-.2,2.22,2.22,0,0,0-1.63-.53H35.76l-6.32,31.9a11.29,11.29,0,0,1-2.78,5.78,6.69,6.69,0,0,1-4.83,1.83,5.2,5.2,0,0,1-3.62-1.06,4.05,4.05,0,0,1-1.07-1.79c-.06-.2-.11-.41-.16-.62l0-.16c0-.21-.07-.44-.1-.68h0a1.44,1.44,0,0,0-.17-.58H0s0,2.13,0,2.61A10.79,10.79,0,0,0,1.09,48.9a14,14,0,0,0,4.72,5.41,23.42,23.42,0,0,0,7.06,3.33,27.43,27.43,0,0,0,7.71,1.14,35.44,35.44,0,0,0,9.1-1.08h0c.54-.14,1.06-.3,1.57-.47l.1,0c.52-.18,1-.37,1.53-.58h0L34,56.1l.42-.22.64-.35.52-.32.45-.29.6-.4.25-.19a18.62,18.62,0,0,0,3-2.75h0a18.63,18.63,0,0,0,1.19-1.47,28.52,28.52,0,0,0,4.54-10.87l.66-3.1L47,55.78a2.56,2.56,0,0,0,.61,1.53,2.35,2.35,0,0,0,2,.73H67.31L81.83,32.68v0L96.64,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.34,45.27,194.11,58.12l0-25.6h0L171.93,19.7,194.22,6.84,216.39,19.7l-.07,0ZM222,16.65,194.06,0l-28,16.65V48.42l28,16.14L222,48.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.94c9ff15992471689691fb795ba22c66.svg";
export { ForwardRef as ReactComponent };